import { useGetContentItemByPath20Suspense } from "#/_generated/umbraco/delivery-api/features/content/content.ts";
import type { StartUmbPageContentResponseModel } from "#/_generated/umbraco/delivery-api/models";

export default function useGetStartPage() {
	const { data } = useGetContentItemByPath20Suspense({}, "/");

	return data?.data ? (data.data as StartUmbPageContentResponseModel) : null;
}
